export const SlipIcon = () => {
    return (
        <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 8h10" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
            <path d="M5 6.5L3.5 8 5 9.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11 6.5L12.5 8 11 9.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

